import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  question: null,
  questions: [],
  question_group: {},
  validate_question: {},
  correctGroupChoosed: [],
  valVituralKeyboard: {},
  questionDataCheckAnswer: [],
  questionList4CheckAnswer: [],
  textSelectedData: []
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};